var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pageBlocks),function(block,index){return _c('Block',{key:block.id,class:_vm.getBackgroundClass(index),attrs:{"block":block,"startBgColor":_vm.getBackgroundClass(index)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }